import {
  Box,
  Grid,
} from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import useStyles from "../../../../themes/style.js";
import { getEmpName } from "../../../../utils/constant";

const OfficeDetails = ({ userDetails, onUpdate }) => {
  const classes = useStyles();
  const [employeeData, setEmployeeData] = useState({});

  useEffect(() => {
    if (userDetails) {
      const employee = userDetails.employee
        ? userDetails.employee
        : userDetails.recruiter;

      setEmployeeData(employee);
    }
  }, [userDetails]);


  const getprobationPeriod = (period) => {
    const probationPeriod = Number(period);
    if (!probationPeriod) {
      return null;
    }

    if (probationPeriod <= 1) {
      return `${probationPeriod} Month`;
    }
    return `${probationPeriod} Months`;
  };

  return (
    <div>
      <Box>
        <div className="emp-profile-details-table-card">
          <h3 className="gradienttext">Office Details</h3>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <table className="emp-profile-details-table">
                <tbody>
                  <tr>
                    <td>Official Email</td>
                    <td>{userDetails.email}</td>
                  </tr>
                  <tr>
                    <td>Designation</td>
                    <td>
                      {userDetails.designation ? (
                        userDetails.designation.title
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Department</td>
                    <td>
                      {userDetails.designation ? (
                        userDetails.designation.department?.title
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Date of Joining </td>
                    <td>
                      {(employeeData?.joinningDate &&
                        moment(employeeData?.joinningDate).format(
                          "DD-MM-YYYY",
                        )) || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Probation period</td>
                    <td>
                      {userDetails.salary_detail?.probationPeriod ? (
                        getprobationPeriod(
                          userDetails.salary_detail.probationPeriod,
                        )
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Grade</td>
                    <td>
                      {userDetails.salary_detail?.grade || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <table className="emp-profile-details-table">
                <tbody>
                  <tr>
                    <td>Direct Reporting To</td>
                    <td>
                      {userDetails.direct_reportingto ? (
                        getEmpName(userDetails.direct_reportingto)
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Dotted Reporting To</td>
                    <td>
                      {userDetails.dot_reportingto ? (
                        getEmpName(userDetails.dot_reportingto)
                      ) : (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Company Branch Name & Address</td>
                    <td>
                      {employeeData?.companyBranchName || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>Employee Id</td>
                    <td>
                      {employeeData?.empId || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Mode Of Work</td>
                    <td>
                      {userDetails.salary_detail?.modeOfWork || (
                        <span className="emp-details-unvailable">
                          Unavailable
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default OfficeDetails;
